import api from './apiService';

const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

export const listPriceGroups = async ({ includeInactive = false } = {}) => {
  const response = await api.get('/api/price-groups', { include_inactive: includeInactive });
  return unwrap(response) || [];
};

export const getPriceGroup = async (groupId) => {
  const response = await api.get(`/api/price-groups/${groupId}`);
  return unwrap(response);
};

export const createPriceGroup = async (payload) => {
  const response = await api.post('/api/price-groups', payload);
  return unwrap(response);
};

export const updatePriceGroup = async (groupId, payload) => {
  const response = await api.put(`/api/price-groups/${groupId}`, payload);
  return unwrap(response);
};

export const activatePriceGroup = async (groupId) => {
  const response = await api.put(`/api/price-groups/${groupId}/activate`, {});
  return unwrap(response);
};

export const deactivatePriceGroup = async (groupId) => {
  const response = await api.delete(`/api/price-groups/${groupId}`);
  return unwrap(response);
};

export const searchPriceGroupProducts = async ({ q, limit = 20 } = {}) => {
  const response = await api.get('/api/price-groups/products/search', { q, limit });
  return unwrap(response) || [];
};

export const addProductToPriceGroup = async (groupId, payload) => {
  const response = await api.post(`/api/price-groups/${groupId}/products`, payload);
  return unwrap(response);
};

export const removeProductFromPriceGroup = async (groupId, productId) => {
  const response = await api.delete(`/api/price-groups/${groupId}/products/${productId}`);
  return unwrap(response);
};

export const applyPriceToGroup = async (groupId, payload) => {
  const response = await api.post(`/api/price-groups/${groupId}/apply-price`, payload);
  return unwrap(response);
};
